const API_BASE_URL = 'https://naus-backend.onrender.com';

export const api = {
  // Submit membership application
  submitApplication: async (formData) => {
    const response = await fetch(`${API_BASE_URL}/api/applications`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });
    return response.json();
  },

  // Get pending applications (for admin)
  getPendingApplications: async () => {
    const response = await fetch(`${API_BASE_URL}/api/admin/applications/pending`);
    return response.json();
  },

  // Approve application (admin only)
  approveApplication: async (applicationId) => {
    const response = await fetch(`${API_BASE_URL}/api/admin/applications/${applicationId}/approve`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.json();
  },

  // Submit contact form
  submitContactForm: async (formData) => {
    const response = await fetch(`${API_BASE_URL}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });
    return response.json();
  }
};